<template>
	<div class="main">
		<div class="bootbox modal fade in show" tabindex="-1" role="dialog" style="display: block;">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-body">
						<button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="closePopup">×</button>
						<div class="bootbox-body">
							<section class="panel">
								<div class="panel-body">
									<div class="row form-group">
										<div class="col-md-12">
											<label>遲到說明(請詳述人、事、時、地、物):</label>
										</div>
										<div class="col-md-12">
											<textarea v-model="popupParam.lateReason" class="form-control" rows="5" maxlength="100"></textarea>
										</div>
									</div>
									<div>
										<div class="col-md-offset-4 col-md-2">
											<a href="javascript:;" class="btn s_btn_b btn-block" @click="closePopup()">返回</a>
										</div>
										<div class="col-md-2">
											<a href="javascript:;" class="btn btn-primary btn-block" @click="save()">儲存</a>
										</div>
									</div>
								</div>
							</section>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ['rollcallRecord'],
	data(){
		return {
			popupParam:{}
		}
	},
	mounted(){
		this.popupParam = this.rollcallRecord;
	},
	methods:{
		closePopup() {
			this.$parent.showPopupControl(false);
		},
		save(){
			this.$parent.saveRollcallSign(this.popupParam);
		}
	}
}
</script>